import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-mutuelle-sante-internationale-pro',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-mutuelle-sante-internationale-pro.component.html',
  styleUrls: ['./assurance-mutuelle-sante-internationale-pro.component.scss']
})
export class AssuranceMutuelleSanteInternationaleProComponent {
  title = 'Assurance Mutuelle Santé Internationale Professionnelle';
  subtitle = '';
  heroImage = 'assets/static_pages_images/the-cardiologist-henri-vaquez.jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'Assurance Mutuelle Santé Internationale', link: undefined }
  ];

  prevPage = { title: 'Assurance Mutuelle Santé Professionnelle', 
    link: '/assurance-sante-professionnels'
  };

  nextPage = { title: 'Assurance Mutuelle Santé Entreprise', 
    link: '/assurance-collective-entreprise'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'ALPTIS', logo: 'assets/logos/ALPTIS.PNG' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'MALAKOFF HUMANIS', logo: 'assets/logos/MALAKOFF.PNG' },
    { name: 'HENNER', logo: 'assets/logos/HENNER.PNG' }
  ];

  constructor(private router: Router) {}

  navigateToContact() {
    this.router.navigate(['/contactez-nous']);
  }
}
